import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

type GetCustomerModelMetadataRequest = {
  scenarioBuilderClient: ScenarioBuilderClient;
};

export const getCustomerModelMetadata = ({
  scenarioBuilderClient,
}: GetCustomerModelMetadataRequest) => {
  return scenarioBuilderClient.validation.getCustomerModelMetadata();
};
